import React from 'react';
import { useNode, useEditor } from "@craftjs/core";
import { FormControl, FormLabel, Typography } from "@mui/material";
import { BasicSettings } from './BasicSettings';
import { OptionsSettings } from './OptionsSettings';
import { BulmaSettings } from './BulmaSettings';
import { IconSettings } from './IconSettings';
import { LabelSettings } from './LabelSettings';
import { LayoutSettings } from './LayoutSettings';
import { StyleSettings } from './StyleSettings';

export const SelectSettings = () => {
  const { 
    actions: { setProp }, 
    name, qwantumId, value, selectName, placeholder,
    options, bulmaSize, bulmaColor, bulmaStyle, bulmaState,
    isMultiple, multipleSize, hasIcon, iconClass, iconPosition,
    labelText, labelFontSize, showSemicolon, labelBold, labelItalic, fontFamily,
    width, maxWidth, minWidth, flex, flexGrow, flexShrink, flexBasis,
    position, top, left, right, bottom, unit, lockedEdges,
    backgroundColor, borderRadius, padding, cssClass, selectClass,
    parent
  } = useNode((node) => ({
    name: node.data.props.name,
    qwantumId: node.data.props.qwantumId,
    value: node.data.props.value,
    selectName: node.data.props.selectName,
    placeholder: node.data.props.placeholder,
    options: node.data.props.options,
    bulmaSize: node.data.props.bulmaSize,
    bulmaColor: node.data.props.bulmaColor,
    bulmaStyle: node.data.props.bulmaStyle,
    bulmaState: node.data.props.bulmaState,
    isMultiple: node.data.props.isMultiple,
    multipleSize: node.data.props.multipleSize,
    hasIcon: node.data.props.hasIcon,
    iconClass: node.data.props.iconClass,
    iconPosition: node.data.props.iconPosition,
    labelText: node.data.props.labelText,
    labelFontSize: node.data.props.labelFontSize,
    showSemicolon: node.data.props.showSemicolon,
    labelBold: node.data.props.labelBold,
    labelItalic: node.data.props.labelItalic,
    fontFamily: node.data.props.fontFamily,
    width: node.data.props.width,
    maxWidth: node.data.props.maxWidth,
    minWidth: node.data.props.minWidth,
    flex: node.data.props.flex,
    flexGrow: node.data.props.flexGrow,
    flexShrink: node.data.props.flexShrink,
    flexBasis: node.data.props.flexBasis,
    position: node.data.props.position,
    top: node.data.props.top,
    left: node.data.props.left,
    right: node.data.props.right,
    bottom: node.data.props.bottom,
    unit: node.data.props.unit,
    lockedEdges: node.data.props.lockedEdges,
    backgroundColor: node.data.props.backgroundColor,
    borderRadius: node.data.props.borderRadius,
    padding: node.data.props.padding,
    cssClass: node.data.props.cssClass,
    selectClass: node.data.props.selectClass,
    parent: node.data.props.parent
  }));

  const { query } = useEditor();
  const parentNode = parent ? query.node(parent).get() : null;

  return (
    <div>
      {parentNode && (
        <FormControl fullWidth margin="normal">
          <FormLabel>Parent: {parentNode.data.displayName || parentNode.data.name || 'Container'}</FormLabel>
        </FormControl>
      )}

      <BasicSettings
        name={name}
        qwantumId={qwantumId}
        selectName={selectName}
        placeholder={placeholder}
        cssClass={cssClass}
        selectClass={selectClass}
        setProp={setProp}
      />

      <OptionsSettings
        options={options}
        setProp={setProp}
      />

      <BulmaSettings
        bulmaColor={bulmaColor}
        bulmaSize={bulmaSize}
        bulmaStyle={bulmaStyle}
        bulmaState={bulmaState}
        isMultiple={isMultiple}
        multipleSize={multipleSize}
        setProp={setProp}
      />

      <IconSettings
        hasIcon={hasIcon}
        iconClass={iconClass}
        iconPosition={iconPosition}
        setProp={setProp}
      />

      <LabelSettings
        labelText={labelText}
        labelFontSize={labelFontSize}
        fontFamily={fontFamily}
        labelBold={labelBold}
        labelItalic={labelItalic}
        showSemicolon={showSemicolon}
        setProp={setProp}
      />

      <LayoutSettings
        width={width}
        maxWidth={maxWidth}
        minWidth={minWidth}
        position={position}
        unit={unit}
        lockedEdges={lockedEdges}
        top={top}
        left={left}
        right={right}
        bottom={bottom}
        flex={flex}
        flexGrow={flexGrow}
        flexShrink={flexShrink}
        flexBasis={flexBasis}
        setProp={setProp}
      />

      <StyleSettings
        backgroundColor={backgroundColor}
        borderRadius={borderRadius}
        padding={padding}
        setProp={setProp}
      />
    </div>
  );
};